import { useEffect } from "react";
import DescriptionWithImageSection from "../components/Common/DescriptionWithImage";
import ContactsSection from "../components/Contacts/ContactsSection";
import ServicesSection from "../components/Services/ServicesSection";
import { useI18n } from "../i18n/I18nContext";

const Services = () => {
  const { copy } = useI18n();
  const servicesCopy = copy.servicesPage;

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);

  return (
    <div>
      <DescriptionWithImageSection
        title={
          <h2>
            {servicesCopy.titleBefore}
            <span style={{ color: "#0668E1" }}>
              {servicesCopy.titleHighlight}
            </span>
          </h2>
        }
        paragraph={
          <p>{servicesCopy.intro}</p>
        }
        imageInfo={{
          link: "/services.webp",
          description: servicesCopy.imageAlt,
        }}
      />
      <ServicesSection />
      <ContactsSection />
    </div>
  );
};

export default Services;
